import toast from './Toast';
import { useToast } from './Toast';

export default toast;
export { useToast };
